import { useLocation } from "react-router";
import { AutoLoanSelectedProductTag } from "./AutoLoanSelectedProductTag";
import { CreditCardSelectedProductTag } from "./CreditCardSelectedProductTag";
import { PersonalLoanSelectedProductTag } from "./PersonalLoanSelectedProductTag";

export function RouteBasedSelectedProductTag() {
  const location = useLocation();
  const firstPathSegment = location.pathname.split("/")[1] ?? "";

  if (firstPathSegment.includes("auto-loan")) {
    return <AutoLoanSelectedProductTag />;
  }

  if (firstPathSegment.includes("credit-card")) {
    return <CreditCardSelectedProductTag />;
  }

  if (firstPathSegment.includes("personal-loan")) {
    return <PersonalLoanSelectedProductTag />;
  }

  return null;
}
